import { namespace, initialMessagesState, MessagesState, reducer as messagesReducer } from './actions';
import Messages from './Messages';

export type State = {
    [namespace]: MessagesState;
}
const reducers = {
    [namespace]: messagesReducer,
};
const initialState = {
    [namespace]: initialMessagesState,
};

export { Messages, namespace, reducers, initialState };
